/**
 * Module CTR tracking (impression + click).
 *
 * Events → gtag → GA4 → BigQuery:
 *   hs_module_impression — ≥50% viewport (once per page load)
 *   hs_module_click      — user action on a module
 *
 * Accordion (pdp_accordion): ONLY fire click when expanding (open=true).
 * Collapse does NOT report. Each of the 5 rows has its own data-hs-module.
 *
 * Attrs on trackable nodes:
 *   data-hs-track            impression + click (default; value may be empty)
 *   data-hs-track="impression"  impression only (section shells / non-CTA areas)
 *   data-hs-section   pdp_* | home_* | gift_tiers | most_popular |
 *                     you_might_also_like | new_arrivals | explore_collections
 *   data-hs-module    Details | Materials | … | product handle | Car Charms | cta
 * Optional: data-hs-index, data-hs-item-id, data-hs-item-name
 */
(function () {
  if (window.__hsModuleTrackBound) return;
  window.__hsModuleTrackBound = true;

  var SEEN = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var SEEN_FALLBACK = SEEN ? null : [];

  function alreadySeen(el) {
    if (SEEN) return SEEN.has(el);
    return SEEN_FALLBACK.indexOf(el) !== -1;
  }

  function markSeen(el) {
    if (SEEN) SEEN.add(el);
    else SEEN_FALLBACK.push(el);
  }

  function fire(eventName, params) {
    var payload = params || {};
    payload.page_location = window.location.href;
    payload.page_path = window.location.pathname;

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    } catch (e) {}

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
      }
    } catch (e) {}

    try {
      if (
        window.Shopify &&
        Shopify.analytics &&
        typeof Shopify.analytics.publish === 'function'
      ) {
        Shopify.analytics.publish(eventName, payload);
      }
    } catch (e) {}
  }

  function readTrack(el) {
    if (!el || !el.getAttribute) return null;
    var section = el.getAttribute('data-hs-section');
    var moduleName = el.getAttribute('data-hs-module');
    if (!section || !moduleName) return null;
    var params = {
      module_section: section,
      module_name: moduleName,
    };
    var idx = el.getAttribute('data-hs-index');
    if (idx) params.module_index = Number(idx) || idx;
    var itemId = el.getAttribute('data-hs-item-id');
    if (itemId) params.item_id = itemId;
    var itemName = el.getAttribute('data-hs-item-name');
    if (itemName) params.item_name = itemName;
    return params;
  }

  function observeImpressions() {
    var nodes = document.querySelectorAll('[data-hs-track]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) {
        var p = readTrack(nodes[i]);
        if (p && !alreadySeen(nodes[i])) {
          markSeen(nodes[i]);
          fire('hs_module_impression', p);
        }
      }
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) continue;
          var el = entry.target;
          if (alreadySeen(el)) continue;
          var params = readTrack(el);
          if (!params) continue;
          markSeen(el);
          fire('hs_module_impression', params);
          io.unobserve(el);
        }
      },
      { threshold: [0.5] }
    );

    for (var j = 0; j < nodes.length; j++) {
      if (alreadySeen(nodes[j])) continue;
      io.observe(nodes[j]);
    }
  }

  /**
   * Accordion expand-only: native <details> fires "toggle" on open AND close.
   * We only report when details.open === true (expand). Each row is its own
   * data-hs-module (Details / Materials / Scent Duration / …).
   */
  document.addEventListener(
    'toggle',
    function (e) {
      var details = e.target;
      if (!details || details.tagName !== 'DETAILS') return;
      if (!details.open) return; /* collapse → no event */
      if (!details.hasAttribute('data-hs-track')) return;
      if (details.getAttribute('data-hs-section') !== 'pdp_accordion') return;

      var params = readTrack(details);
      if (!params) return;
      params.action = 'expand';
      fire('hs_module_click', params);
    },
    true
  );

  /* Non-accordion modules: gift cards / product cards / collection tiles */
  document.addEventListener(
    'click',
    function (e) {
      var path = typeof e.composedPath === 'function' ? e.composedPath() : [];
      if (!path.length) {
        var t = e.target;
        if (t && t.nodeType === 3) t = t.parentElement;
        path = t ? [t] : [];
      }

      var trackEl = null;
      for (var i = 0; i < path.length; i++) {
        var node = path[i];
        if (!node || node.nodeType !== 1) continue;
        if (node.hasAttribute && node.hasAttribute('data-hs-track')) {
          trackEl = node;
          break;
        }
      }
      if (!trackEl) return;

      /* Impression-only shells (e.g. trust bar / reviews) — do not count clicks */
      if (trackEl.getAttribute('data-hs-track') === 'impression') return;

      var section = trackEl.getAttribute('data-hs-section');
      /* Accordions use toggle(expand-only); never count raw clicks here */
      if (section === 'pdp_accordion' || trackEl.tagName === 'DETAILS') return;

      var params = readTrack(trackEl);
      if (!params) return;
      fire('hs_module_click', params);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeImpressions);
  } else {
    observeImpressions();
  }

  document.addEventListener('hs:module-track-refresh', function () {
    observeImpressions();
  });
})();
